import { ISieveSize } from 'Data/ViewModels/Equipment/ISieveSize';
import { pipe } from 'Lib/Hooks/Selectors';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../../Lib/Object/deepEquals';
import { Button, Dropdown, Field, NumericInput, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from '../../../../Layout';
import { IWithWorksheetInjectedProps, WorksheetEquipmentDropdown } from '../../../Core';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';

let AashtoPreparationSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const [testConditionsEditable, setTestConditionsEditable] = useState(false);
  const visualNominalParticleSizeSieveOptions = useSelector(
    pipe(createWorksheetSelector!('Preparation.AllVisualNominalParticleSizeSieves'), (ss) =>
      (ss || []).map((s: ISieveSize) => ({
        value: s.Id,
        label: s.Caption,
      }))
    ),
    deepEquals
  );
  const visualNominalParticleSize = useSelector(createWorksheetSelector!('Preparation.VisualNominalParticleSize'));
  const selectedVisualNominalParticleSizeSieveOption = visualNominalParticleSizeSieveOptions.find(
    (o: any) => o.value === visualNominalParticleSize
  );
  return (
    <>
      {/* Editable fields */}
      <ListFieldSection visible={testConditionsEditable}>
        <FieldSet>
          <Field input={<NumericInput />} name="Equipment.DryingTemperature" />
        </FieldSet>

        <FieldSet>
          <Field
            input={<Dropdown />}
            name="Preparation.VisualNominalParticleSize"
            options={visualNominalParticleSizeSieveOptions}
            simpleValue
          />
        </FieldSet>
      </ListFieldSection>
      {/* Read-only fields */}
      <ListFieldSection visible={!testConditionsEditable}>
        <Field emph input={<TextOutput />} name="Equipment.DryingTemperature" />
        <Field
          emph
          input={<TextOutput />}
          name="Preparation.VisualNominalParticleSize"
          value={
            selectedVisualNominalParticleSizeSieveOption ? selectedVisualNominalParticleSizeSieveOption.label : null
          }
        />
        <div>
          <Button
            onClick={() => {
              setTestConditionsEditable(true);
            }}
          >
            Change
          </Button>
        </div>
      </ListFieldSection>
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Equipment.Balance" />
        <FieldSet>
          <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Equipment.Oven" />
        </FieldSet>
      </ListFieldSection>
    </>
  );
};

AashtoPreparationSection = withInjectedProps(AashtoPreparationSection);

export { AashtoPreparationSection };
export default AashtoPreparationSection;
